import { BiText } from '../types';

/**
 * Datos del perfil comunes a los dos modos (ejecutivo y consejero).
 * Los usa la sección "Sobre mí" de la web y también el generador de los
 * PDF (scripts/cv-pdf), para que web y PDF no se desincronicen.
 */

export interface Idioma {
  name: BiText;
  level: BiText;
}

export interface Premio {
  year: string;
  title: BiText;
}

export interface Libro {
  title: BiText;
  subtitle?: BiText;
  meta: BiText;
  /** Fichero dentro de /public */
  cover?: string;
  icon?: string;
  link?: string;
}

export interface Docencia {
  period: string;
  title: BiText;
  institution: string;
}

export interface Otro {
  label: string;
  text: BiText;
}

/** Perfil personal, en dos párrafos separados por \n */
export const perfilPersonal: BiText = {
  es: 'Nací en junio de 1970. Casado con Teresa, juntos hemos tenido cuatro hijos. Me gusta madrugar…, mucho, lo que aprovecho para estudiar y hacer deporte. Corro, no me gusta, pero lo necesito. Disfruto creando, escuchando y cantando armonías vocales complejas. Toco la guitarra y el piano (peor). Me gustan los aeropuertos, me gusta irme pero también volver. Mi memoria para los acontecimientos es un desastre pero para números, fechas, caras y relaciones es muy buena. Creo que la forma es muy importante, tanto como para mejorar (o empeorar) el fondo.\nMe gustan mucho las personas. Prefiero la cerveza al vino. En otoño soy mi mejor versión y también sonrío mucho en primavera. Prefiero tener experiencias a tener cosas. Aprendí a programar muy joven y me sigue gustando. Le saco chispas a la Excel. Soy un ingeniero de cerebro derecho. Creo que lo que no se mide, no se controla y no se mejora, pero también creo que nada de lo realmente importante en la vida se mide o se controla. Encuentro un reto buscar caminos imposibles cuando todo el mundo ha abandonado. No soy bueno yendo sólo. En la carrera necesitaba ir a clase. Mis apuntes eran los más codiciados porque eran breves y bonitos. Me cuesta mucho enfadarme y muy poco desenfadarme. Uso el humor para casi todo. Una vida me parece poco.',
  en: 'Born in June 1970. Married to Teresa, together we have had four children. I love getting up early (very early), which I use for studying and exercise. I run (I don\'t enjoy it, but I need it). I love creating, listening to and singing complex vocal harmonies. I play guitar and piano (the latter less well). I like airports: I enjoy leaving but also coming back. My memory for events is terrible but excellent for numbers, dates, faces and relationships. I believe that form matters enormously, enough to make (or break) substance.\nI love people. I prefer beer to wine. Autumn is when I am at my best; I also smile a lot in spring. I prefer experiences to things. I learned to programme very young and still enjoy it. I squeeze every last drop out of Excel. I am a right-brained engineer. I believe that what cannot be measured cannot be controlled or improved, but also that nothing truly important in life can be measured or controlled. I relish seeking impossible paths when everyone else has given up. I am not good going it alone. At university I had to attend lectures. My notes were the most sought-after because they were brief and beautiful. It takes a great deal to make me angry, and very little to calm me down. I use humour for almost everything. One life feels like too little.',
};

export const idiomas: Idioma[] = [
  { name: { es: 'Español', en: 'Spanish' }, level: { es: 'Nativo', en: 'Native' } },
  { name: { es: 'Portugués', en: 'Portuguese' }, level: { es: 'Nativo', en: 'Native' } },
  { name: { es: 'Inglés', en: 'English' }, level: { es: 'C1 Fluido', en: 'C1 Fluent' } },
  { name: { es: 'Alemán', en: 'German' }, level: { es: 'Belt 5', en: 'Belt 5' } },
  { name: { es: 'Chino', en: 'Chinese' }, level: { es: 'Belt 8', en: 'Belt 8' } },
];

export const premios: Premio[] = [
  { year: '2010', title: { es: 'Premio AJE Iniciativa Empresarial', en: 'AJE Entrepreneurial Initiative Award' } },
  { year: '2010', title: { es: 'Premio ASTER al mejor emprendedor', en: 'ASTER Best Entrepreneur Award' } },
];

export const docencia: Docencia[] = [
  {
    period: '2026-2027',
    title: {
      es: 'Profesor del Programa Ejecutivo en Inteligencia Artificial: Estrategia, ROI y Gobernanza',
      en: 'Lecturer, Executive Programme in Artificial Intelligence: Strategy, ROI and Governance',
    },
    institution: 'Universidad San Jorge',
  },
];

export const libros: Libro[] = [
  {
    title: { es: 'El Arte de Preguntar', en: 'El Arte de Preguntar' },
    subtitle: {
      es: 'El poder que te conecta con la vida que quieres',
      en: 'The power that connects you to the life you want',
    },
    meta: { es: 'Espasa (Grupo Planeta) · Octubre 2026', en: 'Espasa (Grupo Planeta) · October 2026' },
    cover: 'libro-el-arte-de-preguntar.png',
    link: 'https://elartedepreguntar.es',
  },
  {
    title: { es: 'Creación de Empresas de Moda', en: 'Creating Fashion Companies' },
    meta: { es: 'EUNSA · 2018', en: 'EUNSA · 2018' },
    icon: '📖',
  },
];

export const otros: Otro[] = [
  {
    label: 'Fundación Moderna',
    text: {
      es: 'Miembro de la Fundación y del Comité Permanente. Instrumento de planificación estratégica a largo plazo para la región de Navarra.',
      en: 'Member of the Foundation and Permanent Committee. Long-term strategic planning instrument for the Navarre region.',
    },
  },
  {
    label: '1992-1994',
    text: {
      es: 'Presidente · Federación Navarra de Balonmano',
      en: 'President · Navarre Handball Federation',
    },
  },
];

export const contacto = {
  email: 'dluquin@gmail.com',
  phone: '+34 646 483 334',
  phoneHref: 'tel:+34646483334',
  linkedin: 'linkedin.com/in/davidluquin',
  web: 'cv.luquin.com',
  location: 'Madrid · Pamplona',
};
